import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { fromBankProofDocumentsActions, fromBankProofsActions } from '../actions';
import { IBankProof } from '../models/bank-proof.model';
import { IBankProofDocument } from '../models/bank-proof-documents.model';

export const bankProofDocumentsFeatureKey = 'getBankProofDocuments';

export interface CurrentBankProofDocumentsState {
  currentBankProofRequest: any;
  currentBankProofDocumentsResponse: IBankProofDocument;
  currentBankProofDocumentsFailure: IGenericError<ErrorResponse>;
}

export const initialState: CurrentBankProofDocumentsState = {
  currentBankProofRequest: undefined,
  currentBankProofDocumentsResponse: undefined,
  currentBankProofDocumentsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromBankProofDocumentsActions.loadCurrentBankProofDocuments, (state, action) => ({
    ...state,
    currentBankProofRequest: {
      customerId: action.customerId,
      bankAccountId: action.bankAccountId
    },
    currentBankProofDocumentsResponse: undefined,
    currentBankProofDocumentsFailure: undefined
  })),
  on(fromBankProofDocumentsActions.clearBankProofDocumentsUiState, () => ({ ...initialState })),
  on(fromBankProofDocumentsActions.loadCurrentBankProofDocumentsSuccess, (state, action) => ({
    ...state,
    currentBankProofDocumentsResponse: action.response
  })),
  on(fromBankProofDocumentsActions.loadCurrentBankProofDocumentsFailure, (state, action) => ({
    ...state,
    currentBankProofDocumentsFailure: action.error
  }))
);

export const getCurrentBankProofDocumentsResponse = (state: CurrentBankProofDocumentsState) => {
  return state.currentBankProofDocumentsResponse;
};
export const getCurrentBankProofDocumentsFailure = (state: CurrentBankProofDocumentsState) => state.currentBankProofDocumentsFailure;
